export default (editor) => editor.temporaryAnnotations;
